<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.16665 3.5L5.97915 6.41667L7.64165 8.63333L6.70831 9.33333C5.72248 8.02083 4.08331 5.83333 4.08331 5.83333L0.583313 10.5H13.4166L8.16665 3.5Z" fill="#009E50"/>
  </svg>
</template>>
